import React from 'react'
import { PictureAreaDiv } from './style'
import hero from '../../../assets/images/hero.jpg'
import {BsArrowRight} from 'react-icons/bs'

function PictureArea() {
    return (
        <PictureAreaDiv>
            <div className="inner-container row roww m-5">
                <div className="firstdiv col-md-4 pt-5">
                    <h4>Combating Covid 19 with technology</h4>
                    <p>Read awesome/healthy tippy blog <br/>
                    post from ...</p>
                    <a href="">
                        <p>Read more <BsArrowRight /></p>
                    </a>
                    
                </div>
                <div className="seconddiv col-md-4">
                    <div className="firstsmall pt-5">
                        <h4>Combating Covid 19 with technology</h4>
                            <p>Read awesome/healthy tippy blog <br/>
                             post from ...</p>
                             <a href="">
                                <p>Read more <BsArrowRight /></p>
                            </a>

                    </div>
                    <div className="secondsmall pt-5">
                        <h4>Combating Covid 19 with technology</h4>
                            <p>Read awesome/healthy tippy blog <br/>
                            post from ...</p>
                            <a href="">
                                <p>Read more <BsArrowRight /></p>
                            </a>
                    </div>

                </div>
                <div className="thirddiv container col-md-4 pt-5">
                <h4>Combating Covid 19 with technology</h4>
                    <p>Read awesome/healthy tippy blog <br/>
                    post from ...</p>
                      <a href="">
                        <p>Read more <BsArrowRight /></p>
                    </a>
                </div>

            </div>
            
        </PictureAreaDiv>
    )
}

export default PictureArea
